import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { username, password });
      localStorage.setItem("bdd_token", r.data.token);
      localStorage.setItem("bdd_user", r.data.username);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="px-6 py-4 border-b border-zinc-900 bg-zinc-950/60 backdrop-blur">
        <Logo />
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <Link
            to="/"
            data-testid="admin-back-home"
            className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-white mb-8"
          >
            <ArrowLeft size={12} /> Torna al sito
          </Link>

          <div className="inline-flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-full px-3 py-1 mb-4">
            <Lock size={12} className="text-[#FBD51C]" />
            <span className="text-[10px] font-mono-bdd uppercase tracking-[0.25em] text-zinc-400">
              Area Riservata
            </span>
          </div>
          <h1 className="font-display font-black text-3xl text-white mb-2">
            Pannello admin
          </h1>
          <p className="text-zinc-500 text-sm mb-8">
            Accedi per gestire offerte, importazione Telegram e pubblicità.
          </p>

          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-[10px] font-mono-bdd uppercase tracking-[0.25em] text-zinc-500 mb-2">
                Username
              </label>
              <input
                data-testid="admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-3 text-white outline-none focus:border-[#FBD51C]/60 focus:ring-2 focus:ring-[#FBD51C]/20"
              />
            </div>
            <div>
              <label className="block text-[10px] font-mono-bdd uppercase tracking-[0.25em] text-zinc-500 mb-2">
                Password
              </label>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-3 text-white outline-none focus:border-[#FBD51C]/60 focus:ring-2 focus:ring-[#FBD51C]/20"
              />
            </div>

            {err && (
              <div data-testid="admin-error" className="text-sm text-rose-400 bg-rose-950/40 border border-rose-900/60 rounded-lg px-3 py-2">
                {err}
              </div>
            )}

            <button
              type="submit"
              data-testid="admin-submit"
              disabled={loading}
              className="w-full bg-[#FBD51C] hover:bg-[#F5C518] disabled:opacity-50 text-black font-black uppercase tracking-wider text-sm py-3 rounded-lg transition-colors"
            >
              {loading ? "Accesso..." : "Entra"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
